import {useState} from 'react';

import {IBeerPrice} from 'typescript/interfaces/BeerPrice';
import {BeerPrice} from 'typescript/models/BeerPrice';

export const useBeerPrices = (): [
  IBeerPrice[],
  (beerPrices: BeerPrice[]) => void,
  ({id, field, value}: {id: number; field: string; value: string}) => void,
  (id: number) => void,
] => {
  const [prices, setPrices] = useState<IBeerPrice[]>([
    {id: 1, price: '', amount: '', currency: '0'},
    {id: 2, price: '', amount: '', currency: '0'},
    {id: 3, price: '', amount: '', currency: '0'},
  ]);

  const setBeerPrices = (beerPrices: BeerPrice[]) => {
    const valuesMap: {[key: string]: string} = {
      RSD: '0',
      EUR: '1',
      USD: '2',
    };

    const formattedPrices = beerPrices.map(({id, price, amount, currency}) => {
      const newPrice: IBeerPrice = {
        id,
        price,
        amount,
        currency: valuesMap[currency],
        existingPrice: true,
      };

      return newPrice;
    });

    while (formattedPrices.length < 3) {
      formattedPrices.push({id: Math.random(), price: '', amount: '', currency: '0'});
    }

    setPrices(formattedPrices);
  };

  const handleUpdatePrice = ({id, field, value}: {id: number; field: string; value: string}) => {
    setPrices((currPrices) =>
      currPrices.map((price) => {
        if (id === price.id) {
          price[field] = value;

          if (price.amount && price.price) price.destroy = false;
        }

        return price;
      }),
    );
  };

  const handleRemovePrice = (id: number) => {
    setPrices((currPrices) =>
      currPrices.map((beerPrice) => {
        if (beerPrice.id === id) {
          beerPrice.amount = '';
          beerPrice.price = '';
          beerPrice.currency = '0';
          if (beerPrice.existingPrice) beerPrice.destroy = true;
        }

        return beerPrice;
      }),
    );
  };

  return [prices, setBeerPrices, handleUpdatePrice, handleRemovePrice];
};
